module.exports = __webpack_public_path__ + "img/detail-btn.96b8a6d9.png";